import BucketApiRequest from "./BucketApiRequest";
import { GET_ACCOUNT_PURPOSE_URL } from "../ApiUrls";

export default class AccountPurposeRequest extends BucketApiRequest {
  getUrl = () => {
    return GET_ACCOUNT_PURPOSE_URL;
  };
}
